import { RollupType, toRollupType } from 'pages/raas/helpers/labels';
import { getRpsMetricPanel } from 'pages/raas/helpers/rollup';
import { useRaasDeployment, useRaasMetrics, useRpcInstances } from 'pages/raas/hooks';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Metric } from 'shared/components/metric';

import { useDateRangeFilterOptions } from '../../hooks/useDateRangeFilterOptions';
import { DateFilterVariant } from '../../store';
import { getRpsTemplate } from './helpers';

interface IRpsMetric {
  instance: string;
}

const RpsMetric: React.FC<IRpsMetric> = ({ instance }) => {
  const { rollupId } = useParams();
  const { data: rollup } = useRaasDeployment();
  const { data: rpcInstancesData } = useRpcInstances();

  const { end, start, step, timeframe } = useDateRangeFilterOptions(
    DateFilterVariant.RPS_METRIC_SECTION,
  );

  const { data: result, isPending } = useRaasMetrics({
    panel: getRpsMetricPanel(toRollupType(rollup?.type)),
    timeframe,
    rollupId,
    start,
    end,
    step,
    rpcInstance: instance,
    template: getRpsTemplate(timeframe),
  });

  return (
    <Metric
      chartType="area"
      data={result}
      hideLegend
      hideMoreButton
      id="rpc-count"
      limit={
        rollup?.type === RollupType.ORBIT
          ? { value: rpcInstancesData?.rpsLimit ?? 0, label: 'RPS Limit' }
          : undefined
      }
      loading={isPending}
      timeframe={timeframe}
      xAxisProps={{
        dataKey: 'date',
      }}
      yAxisProps={{
        tickFormatter: value => new Intl.NumberFormat().format(value),
      }}
    />
  );
};

export default RpsMetric;
